import api from "@/api/api";

export const getMetricsTotals = ({ entityId, dateFrom, dateTo } = {}) => {
  return api.get(`/metrics/${entityId}/overview/totals`, {
    params: { dateFrom, dateTo },
  });
};

export const getMetricsAverageScore = ({
  entityId,
  dateFrom,
  dateTo,
  period,
} = {}) => {
  return api.get(`/metrics/${entityId}/overview/average-score`, {
    params: { dateFrom, dateTo, period },
  });
};

export const getMetricsFlagsChart = ({
  entityId,
  dateFrom,
  dateTo,
  period,
  type,
  metric,
} = {}) => {
  return api.get(`/metrics/${entityId}/overview/flags-chart`, {
    params: { dateFrom, dateTo, period, type, metric },
  });
};

export const getMetricsPerformanceTrends = ({
  entityId,
  classIds,
  assignmentIds,
  dateFrom,
  dateTo,
  period,
} = {}) => {
  return api.get(`/metrics/${entityId}/performance-trends`, {
    params: { classIds, assignmentIds, dateFrom, dateTo, period },
    paramsSerializer: { indexes: null },
  });
};

export const getMetricsClassAssignmentSummary = ({
  entityId,
  classIds,
  dateFrom,
  dateTo,
  sort,
  page,
  limit,
} = {}) => {
  return api.get(`/metrics/${entityId}/assignment-summary`, {
    params: { classIds, dateFrom, dateTo, sort, page, limit },
    paramsSerializer: { indexes: null },
  });
};

export const getMetricsClassesDrillDown = ({
  entityId,
  dateFrom,
  dateTo,
  page,
  limit,
  platform,
  search,
  sortBy,
  sortOrder,
} = {}) => {
  return api.get(`/metrics/${entityId}/overview/classes-drill-down`, {
    params: {
      dateFrom,
      dateTo,
      page,
      limit,
      platform,
      search,
      sortBy,
      sortOrder,
    },
  });
};

export const getMetricsOverallInfo = ({
  entityId,
  classIds,
  assignmentIds,
  dateFrom,
  dateTo,
} = {}) => {
  return api.get(`/metrics/${entityId}/overall-info`, {
    params: { classIds, assignmentIds, dateFrom, dateTo },
    paramsSerializer: { indexes: null },
  });
};

export const getMetricsStudentGrowth = ({
  entityId,
  classIds,
  assignmentIds,
  dateFrom,
  dateTo,
} = {}) => {
  return api.get(`/metrics/${entityId}/student-growth`, {
    params: { classIds, assignmentIds, dateFrom, dateTo },
    paramsSerializer: { indexes: null },
  });
};

export const getMetricsFolder = async ({ entityId, folderId } = {}) => {
  const res = await api.get(`/folders/${entityId}/${folderId}`);
  return res.data;
};

export const getMetricsAssignmentSummary = ({
  entityId,
  classId,
  assignmentId,
} = {}) => {
  return api.get(
    `/metrics/${entityId}/class/${classId}/assignment/${assignmentId}/summary`
  );
};

export const getMetricsRubricBreakdown = ({ entityId, assignmentId } = {}) => {
  return api.get(`/metrics/${entityId}/${assignmentId}/rubric-breakdown`);
};

export const getMetricsStudentBreakdown = ({ entityId, assignmentId } = {}) => {
  return api.get(`/metrics/${entityId}/${assignmentId}/student-breakdown`);
};

export const getMetricsAssignmentInsights = ({
  entityId,
  assignmentId,
} = {}) => {
  return api.get(`/metrics/${entityId}/insights/assignment/${assignmentId}`);
};

export const getMetricsClassInsights = ({ entityId, classId } = {}) => {
  return api.get(`/metrics/${entityId}/insights/class/${classId}`);
};

export const getMetricsStudentProgressChart = ({
  entityId,
  studentId,
  classIds,
  assignmentIds,
  dateFrom,
  dateTo,
} = {}) => {
  return api.get(`/metrics/${entityId}/students/${studentId}/progress-chart`, {
    params: { classIds, assignmentIds, dateFrom, dateTo },
    paramsSerializer: { indexes: null },
  });
};

export const getMetricsStudentClassRanking = ({
  entityId,
  studentId,
  classIds,
  assignmentIds,
  dateFrom,
  dateTo,
} = {}) => {
  return api.get(`/metrics/${entityId}/students/${studentId}/class-ranking`, {
    params: { classIds, assignmentIds, dateFrom, dateTo },
    paramsSerializer: { indexes: null },
  });
};

export const getMetricsStudentInsights = ({ entityId, studentId } = {}) => {
  return api.get(`/metrics/${entityId}/insights/student/${studentId}`);
};

export const getMetricsStudentPerformance = ({
  entityId,
  assignmentId,
  page,
  limit,
  sortBy,
  sortDir,
} = {}) => {
  return api.get(`/metrics/${entityId}/${assignmentId}/student-performance`, {
    params: { page, limit, sortBy, sortDir },
  });
};
